import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRewardCustomerList = createAsyncThunk("fetchRewardCustomerList", async ({ filters, page, limit }, { rejectWithValue }) => {
	try {
		const params = new URLSearchParams({
			page: page,
			limit: limit,
			userTypeId: filters?.userTypeId ?? "",
			cityId: filters?.cityId ?? "",
			keyword: filters?.keyword ?? "",
			channel_uuid: filters?.channel_uuid ?? "",
			warehouse_id: filters?.warehouse_id ?? "",
		});

		const response = await axiosHttp.get(`customer/list?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while fetching the user list");
	}
});

const RewardCustomerSlice = createSlice({
	name: "RewardUserSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardCustomerList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchRewardCustomerList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.current_page || 1;
			state.total = action.payload.total || 0;
		});

		builder.addCase(fetchRewardCustomerList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error.message || "Unknown error occurred";
		});
	},
});

export default RewardCustomerSlice.reducer;
